import { Radio } from 'antd'
import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

export const PrimaryRadio = styled(Radio)`
  font-size: ${variables.fontSize18};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};

  &&.ant-radio-wrapper-disabled {
    cursor: not-allowed;
  }

  &&.ant-radio-wrapper-disabled .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.mediumGrey} !important;
    background-color: transparent !important;
  }

  .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.darkGrey};
    background-color: ${({ theme }) => theme.color.white};
  }

  &.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.brandGreen} !important;
    background-color: ${({ theme }) => theme.color.lightGreen} !important;
    &::after {
      background-color: ${({ theme }) => theme.color.brandGreen};
      transform: scale(0.5) !important;
    }
  }

  .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.brandGreen} !important;
    background-color: ${({ theme }) => theme.color.white} !important;
    box-shadow: none !important;
  }

  &.ant-radio-wrapper:not(.ant-radio-wrapper-disabled):hover .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.darkGrey} !important;
    background-color: ${({ theme }) => theme.color.white} !important;
    box-shadow: 0 0 0 8px ${({ theme }) => theme.color.lightGrey} !important;
  }

  &.ant-radio-wrapper:not(.ant-radio-wrapper-disabled):hover
    .ant-radio-checked
    .ant-radio-inner {
    background-color: ${({ theme }) => theme.color.lightGreen} !important;
    border-color: ${({ theme }) => theme.color.brandGreen} !important;
    box-shadow: 0 0 0 8px ${({ theme }) => theme.color.lightGreen} !important;
  }

  &.ant-radio-wrapper:not(.ant-radio-wrapper-disabled):active .ant-radio-inner {
    background-color: ${({ theme }) => theme.color.lightGrey} !important;
    border-color: ${({ theme }) => theme.color.slateGrey} !important;
    box-shadow: none !important;
  }

  &.ant-radio-wrapper:active .ant-radio-inner::after {
    background-color: ${({ theme }) => theme.color.slateGrey};
  }

  span {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`
